import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { TextTranslatePage } from './pages/TextTranslatePage';
import { VoiceSessionPage } from './pages/VoiceSessionPage';
import { LearningPage } from './pages/LearningPage';
import { HistoryPage } from './pages/HistoryPage';
import { OCRTranslatePage } from './pages/OCRTranslatePage';
import { LoginPage } from './pages/LoginPage';
import { MagicLinkVerifyPage } from './pages/MagicLinkVerifyPage';
import { SettingsPage } from './pages/SettingsPage';
import { ThemeProvider } from './hooks/useTheme';
import { learningRoutes } from './learningRoutes';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/verify" element={<MagicLinkVerifyPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<Layout />}>
                <Route path="/" element={<TextTranslatePage />} />
                <Route path="/voice" element={<VoiceSessionPage />} />
                <Route path="/ocr" element={<OCRTranslatePage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/learn" element={<LearningPage />} />
                <Route path="/learning" element={<LearningPage />} />
                {learningRoutes.map(({ path, Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
